import { render, staticRenderFns } from "./MenuAuthority.vue?vue&type=template&id=144ecaaa&"
import script from "./MenuAuthority.vue?vue&type=script&lang=ts&"
export * from "./MenuAuthority.vue?vue&type=script&lang=ts&"
import style0 from "./MenuAuthority.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MenuAuthority.vue"
export default component.exports